import type { ObservationDeleteButtonProps } from "./observation-delete-button.type";

import { DeleteOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { useObservationDeleteButton } from "./observation-delete-button.hook";

export const ObservationDeleteButton = (
  props: ObservationDeleteButtonProps
) => {
  const { t } = useTranslation();
  const { loading, disabled, hideButton, onDeleteClick } =
    useObservationDeleteButton(props);

  if (hideButton) return null;

  return (
    <Button
      icon={<DeleteOutlined />}
      loading={loading}
      disabled={disabled}
      onClick={onDeleteClick}
    >
      {t("observation:delete.button")}
    </Button>
  );
};
